import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
} from '../'
import Styles from './ResolutionText.css'

@CSSModules(Styles, {allowMultiple: true})
export default class ComcastResolutionText extends Component {
  render() {
    return (
      <div>
        <p>
          <Link
            to='https://www.asyousow.org/resolutions/2021/12/20-comcast-report-on-aligning-retirement-plan-options-with-company-climate-goals'
            title={'Comcast shareholder resolution'}
            xstrong
          >
            More resolution details<LinkIcon/>
          </Link>
        </p>

        <blockquote styleName='company-resolution-blockquote'>
          <p>
            <b>WHEREAS:</b>  Shareholders applaud Comcast for adopting ambitious operational climate goals:
          </p>
          <ul>
            <li>
              <p>
                Recently setting the ambitious goal of being carbon neutral by 2035 in Scope 1 and 2 emissions across entire global operations.
              </p>
            </li>

            <li>
              <p>
                Committing to purchasing 100% renewable energy for cable facilities and network operations in Houston, Texas.
              </p>
            </li>

            <li>
              <p>
                Installing fuel efficiency software in 17,500 of cable vans and trucks between 2016 and 2018.
              </p>
            </li>
          </ul>

          <p>
            While the Company has made significant efforts to address climate change across its operations, data from Securities and Exchange Commission (SEC) filings demonstrates misalignment between the Company’s sustainability goals and investment options offered through the Comcast Corporation Retirement-Investment Plan.
          </p>

          <p>
            Every investment fund offered by the Comcast retirement plan, including the default option (holding 52% of employee investments), contains major oil and gas, fossil-fired utilities, coal, pipelines, oil field services, or companies in the agribusiness sector with deforestation risk.
          </p>

          <p>
            A recent scorecard, produced by investor representative As You Sow, shows that the Comcast retirement plan default option is rated poor due to significant investments in fossil fuel companies and companies with deforestation risk.
          </p>

          <p>
            Comcast’s retirement plan currently offers no diversified equity funds that are low carbon, defined as intentionally avoiding investments in fossil fuels companies, companies with deforestation risk, and companies with high carbon emissions. It offers zero funds screened for environmental/social impact.
          </p>

          <p>
            As a result of these limited options, the vast majority of the $15.1 billion employee retirement dollars invested through the Comcast Corporation Employee Savings Plans Master Trust as of December 2020 was invested in funds rated poorly on carbon emissions.
          </p>

          <p>
            Comcast’s investment in high carbon companies through its retirement plan choices directly contradicts the climate reduction actions it has committed to take in its operations, creating cognitive dissonance and reputational risk. This may also make it more difficult to retain employees who are increasingly concerned about catastrophic climate impacts. The climate impact of continuing to choose high carbon retirement plan investments options over low carbon choices raises red flags for the Company’s reputation.
          </p>

          <p>
            <b>BE IT RESOLVED:</b>  Shareholders request the Board, at reasonable expense and excluding proprietary information, prepare a report reviewing the Company’s retirement plan options with the board’s assessment of how the Company’s current retirement plan options align with its climate action goals.
          </p>

          <p>
            <b>SUPPORTING STATEMENT:</b>  Proponent suggests the report include, at Board discretion:
          </p>

          <ul>
            <li>
              <p>
                How Comcast could provide employees with more sustainable investment options such as a default option that is better aligned with global and Company climate goals;
              </p>
            </li>

            <li>
              <p>
                If the Board does not intend to include additional low carbon investment options in its employee retirement plan, a statement of the basis for its decision.
              </p>
            </li>
          </ul>
        </blockquote>
      </div>
    )
  }
}